/**
 * The pages a visitor must be able to read before they decide anything.
 *
 * The consent surface is a blocking dialog in the regions that require an
 * explicit choice, and it is mounted over every route. On the legal pages that
 * is backwards: the privacy statement is what somebody reads *in order to*
 * make the choice, and the Terms of Use are what they read before agreeing to
 * anything at all. A dialog in front of either asks them to decide with the
 * explanation covered up.
 *
 * Nothing optional runs while the surface is not drawn — no choice is no
 * consent — so leaving it off these pages costs the measurement nothing and
 * the visitor gets it on the next page they open.
 */

/** Each is a whole subtree: `/terms/2026-09-14` is as legal as `/terms`. */
export const LEGAL_PATHS = ["/privacy", "/terms"] as const;

export function isLegalPage(pathname: string): boolean {
  return LEGAL_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}
